const preTitle = `
<h3 dir="rtl" id="reviewsOnHerWritingsInObituaries">
    <span class="c2">בקורת על כתיבתה משולבת בהספדים</span>
</h3>
`;

export default preTitle;
